import { ClientRegistrationForm } from "../../organisms/form/ClientRegistrationForm";
import { MainTemplate } from "../../templates/MainTemplate";
import { useClientRegistration } from "./hook";

export const ClientRegistrationPage: React.FC = () => {
  const { handleCancel, handleRegisterClient } = useClientRegistration();

  return (
    <MainTemplate title="新規顧客登録">
      <ClientRegistrationForm
        onCancel={handleCancel}
        handleSubmit={handleRegisterClient}
      />
    </MainTemplate>
  );
};
